// extracted by mini-css-extract-plugin
export var option = "_5i-0";
export var optionCard = "_5i-f";
export var optionContent = "_5i-g";
export var optionIcon = "_5i-i";
export var optionIconBox = "_5i-h";
export var optionLabel = "_5i-j";
export var optionPill = "_5i-m";
export var optionPillBadge = "_5i-p";
export var optionPillIcon = "_5i-n";
export var optionPillLabel = "_5i-o";
export var optionRadio = "_5i-k";
export var optionRadioInner = "_5i-l";
export var optionReveal = "_5i-2";
export var optionRevealDelay0 = "_5i-3";
export var optionRevealDelay1 = "_5i-4";
export var optionRevealDelay10 = "_5i-d";
export var optionRevealDelay11 = "_5i-e";
export var optionRevealDelay2 = "_5i-5";
export var optionRevealDelay3 = "_5i-6";
export var optionRevealDelay4 = "_5i-7";
export var optionRevealDelay5 = "_5i-8";
export var optionRevealDelay6 = "_5i-9";
export var optionRevealDelay7 = "_5i-a";
export var optionRevealDelay8 = "_5i-b";
export var optionRevealDelay9 = "_5i-c";
export var optionSelected = "_5i-1";